import React from 'react';

import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import {
    isRedirectRecordsLoading,
    getRedirectRecords,
} from '@src/selectors';

const RedirectRecords = (props) => {
    const { pathname, search, redirectRecordsData } = props;

    if (process.env.REDIRECTS_ENABLED && redirectRecordsData) {
        const redirectRecordsLoaded = !isRedirectRecordsLoading(redirectRecordsData);
        const redirects = redirectRecordsLoaded ? getRedirectRecords(redirectRecordsData).toJS() : [];

        if (redirects && redirects.length > 0) {
            let redirectUrl = null;
            const sourceUrl = redirects[0].source_url.replace('*', '');
            const splat = pathname.replace(sourceUrl, '');

            if (redirects[0].target_url.endsWith(':splat')) {
                if (sourceUrl === pathname.replace(splat, '')) {
                    redirectUrl = redirects[0].target_url.replace(':splat', splat);
                    redirectUrl += search;
                }
            } else {
                redirectUrl = redirects[0].target_url;
            }

            if (redirectUrl) {
                if (redirectUrl.startsWith('https://')) {
                    window.location.replace(redirectUrl);
                } else {
                    return <Redirect to={redirectUrl} />;
                }
            }
        }
    }

    return props.children;
};

RedirectRecords.propTypes = {
    redirectRecordsData: PropTypes.object,
    pathname: PropTypes.string,
    search: PropTypes.string,
    children: PropTypes.node,
    location: PropTypes.shape({
        search: PropTypes.string,
    }),
};

export default RedirectRecords;
